import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { Plus } from '../../helpers/icon-dictionary';
import css from './index.scss';
import Button from '../../components/button/index';
import TeacherClassList from '../teacher-class-list/index';
import messages from './messages';

const TeacherClassDetail = ({
    editTeacherDetail,
    handleOnUnassignTeacher,
    productName,
    isUnassignedModalOpen,
    handleOnUnassignConfirm,
    handleOnCloseModal,
    unassignTeachersSuccessConfirmation,
    showUnassignTeacherModal,
    isLoading,
    downloadingClassroomIds,
    intl,
    handleOnAssignClass
}) => {
    const assignedClassrooms = editTeacherDetail !== undefined ? editTeacherDetail.assignedClassrooms : [];
    return (
        <div className={css.classDetailComponent}>
            <div className={css.title}>{intl.formatMessage(messages.classDetails)} ({productName})</div>
            <div className={css.header}>
                <TeacherClassList
                    assignedClassrooms={assignedClassrooms}
                    downloadingClassroomIds={downloadingClassroomIds}
                    handleOnCloseModal={handleOnCloseModal}
                    handleOnTeacherUnassign={handleOnUnassignTeacher}
                    handleOnUnassignConfirm={handleOnUnassignConfirm}
                    isLoading={isLoading}
                    isUnassignedModalOpen={isUnassignedModalOpen}
                    showUnassignTeacherModal={showUnassignTeacherModal}
                    unassignTeachersSuccessConfirmation={unassignTeachersSuccessConfirmation}
                />
            </div>
            <div className={css.footer}>
                <Button
                    containerClassName={css.assignClass}
                    handleOnClick={handleOnAssignClass}
                    icon={Plus}
                    iconClassName={css.icon}
                    label={intl.formatMessage(messages.assignClasses)} />
            </div>
        </div>
    );
};

TeacherClassDetail.propTypes = {
    editTeacherDetail: PropTypes.object,
    productName: PropTypes.string,
    handleOnUnassignTeacher: PropTypes.func,
    handleOnUnassignConfirm: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    unassignTeachersSuccessConfirmation: PropTypes.func,
    isUnassignedModalOpen: PropTypes.bool,
    showUnassignTeacherModal: PropTypes.bool,
    isLoading: PropTypes.bool,
    downloadingClassroomIds: PropTypes.object,
    intl: intlShape.isRequired,
    handleOnAssignClass: PropTypes.func
};

export default injectIntl(styleable(css)(TeacherClassDetail));



// WEBPACK FOOTER //
// ./app/components/teacher-class-detail/index.js